import { GreenTrophyIcon } from '@wwe-portal/ui/components/icons/green-trophy';
import { Each } from '@wwe-portal/ui/components/utils';
import { cn } from '@wwe-portal/ui/lib/lib';
import ribbonImg from '@wwe-portal/ui/assets/images/store-revamp/ribbon.webp';

export function Reward({
  rewards,
  className,
}: Readonly<{ rewards: string[]; className?: string }>) {
  return (
    <div
      className={cn(
        'text-text300 relative -left-[9px] mb-2 flex h-[54px] w-[382px] items-center justify-center bg-repeat-round',
        className
      )}
      style={{ backgroundImage: `url(${ribbonImg})` }}
    >
      {Boolean(rewards.length) && (
        <div className="font-poppins mb-3 line-clamp-2 pl-16 pr-4 text-center text-sm font-semibold">
          <Each
            data={rewards}
            render={(reward) => <div key={reward}>{reward}</div>}
          />
        </div>
      )}
      <GreenTrophyIcon className="absolute left-4 -mt-3 h-[56px] w-[44px]" />
    </div>
  );
}
